/** @jsxImportSource @emotion/react */
import { Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useAppTheme } from '@hooks/useAppTheme';
import { selectCurrentNote } from '@state-mgmt/slices/notesSlice';
import { styles } from './styles';
import { usePhotoShare } from '@hooks/usePhotoShare';
import { useDeleteUploadConfirmationModal } from '@hooks/modals/useDeleteUploadConfirmationModal';

const PhotoList = ({ onDelete, deletedUploads }: { deletedUploads?: string[] | null | undefined; onDelete: (valueId: any) => void }) => {
  const { t } = useTranslation();
  const theme = useAppTheme({});
  const selectedNote = useSelector(selectCurrentNote);

  return selectedNote && Array.isArray(selectedNote.media) && selectedNote.media.length ? (
    <div>
      <Typography variant="body2" css={styles.subtitle(theme)}>
        {t('edit-field-note.photos-list')}
      </Typography>

      {selectedNote && Array.isArray(selectedNote.media) && selectedNote.media.length > 0 ? (
        <div css={styles.photos(theme)}>
          {selectedNote.media.map((media: any, i: number) => {
            const deleted = deletedUploads?.includes(media.upload_id);
            return !deleted ? <PhoneItem media={media} onDelete={onDelete} /> : null;
          })}
        </div>
      ) : null}
    </div>
  ) : null;
};

const PhoneItem = ({ media, onDelete }: { media: any; onDelete: (valueId: any) => void }) => {
  const { t } = useTranslation();

  const { savePhoto } = usePhotoShare({ url: media.bucket_location });

  const { displayModal: displayDeleteUploadConfirmModal } = useDeleteUploadConfirmationModal();

  return (
    <div>
      <div style={{ backgroundImage: `url(${media.bucket_location})` }} css={styles.thumbnail} />
      <div css={styles.photosActions}>
        <Button variant="text" size="small" color="error" onClick={() => displayDeleteUploadConfirmModal(() => onDelete(media.upload_id))}>
          {t('general.delete')}
        </Button>
        <Button variant="text" size="small">
          <a download css={styles.downloadBtn} onClick={savePhoto}>
            {t('general.download')}
          </a>
        </Button>
      </div>
    </div>
  );
};

export default PhotoList;
